exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  width: 750px; }\n\n.style__textArea___qy4-D {\n  font-size: 16px;\n  overflow-y: scroll;\n  width: 100%;\n  height: 300px;\n  border-radius: 5px;\n  padding: 10px 20px 10px 20px;\n  border-color: lightgrey;\n  margin: 10px 0px 10px 0px; }\n", ""]);

// exports
exports.locals = {
	"textArea": "style__textArea___qy4-D"
};